import { __assign } from 'tslib';
import { createHtmlRenderState } from '../../html/utils/create-render-state.js';

var createSvgRenderState = function () { return (__assign(__assign({}, createHtmlRenderState()), { attrs: {} })); };

export { createSvgRenderState };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.js
// module id = 121
// module chunks = 0